import React, { useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

import { Loader2, MoreHorizontal } from "lucide-react";
import { DataPendaftaran } from "@/types";
import Modal from "@/components/Modal";
import FormHeader from "@/components/FormHeader";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";
import api from "@/lib/axios";
import FormUpdateProdi from "./FormUpdateProdi";

const postDataUnvalidStatusPendaftaran = async ({
  id_data_pendaftaran,
}: {
  id_data_pendaftaran: string;
}) => {
  const response = await api.post(
    "/operator-pasca/data-pendaftaran/unvalid-pendaftaran",
    { id_data_pendaftaran },
  );

  return response.data;
};

export default function Actions({ row }: { row: DataPendaftaran }) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showUpdateProdi, setShowUpdateProdi] = useState(false);
  const [selectedRow, setSelectedRow] = useState<DataPendaftaran | null>(null);

  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postDataUnvalidStatusPendaftaran,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listDataPendaftaran"] });
      setShowConfirmation(false);
      toast.success(data?.message || "Success.");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
    },
  });

  const handleUnvalid = () => {
    mutate({
      id_data_pendaftaran: String(selectedRow?.id_data_pendaftaran) || "",
    });
  };

  if (!row.is_valid_pendaftaran) return null;

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowConfirmation(true);
                setSelectedRow(row);
              }}
            >
              Unvalid Pendaftaran
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setShowUpdateProdi(true);
                setSelectedRow(row);
              }}
            >
              Update Prodi
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal show={showConfirmation} onClose={() => setShowConfirmation(false)}>
        <FormHeader
          title="Konfirmasi Unvalid Status Pendaftaran"
          description={`Aapakah anda yakin akan meng-unvalid status pendaftaran peserta ${selectedRow?.data_siswa?.nama_lengkap}?`}
          icon={<></>}
        />
        <div className="mt-5 flex gap-3">
          <Button
            variant={"outline"}
            onClick={() => setShowConfirmation(false)}
            disabled={isPending}
          >
            Batal
          </Button>
          <Button onClick={handleUnvalid} disabled={isPending}>
            {isPending ? (
              <>
                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                Processing...
              </>
            ) : (
              "Ya, Unvalid"
            )}
          </Button>
        </div>
      </Modal>

      <Modal show={showUpdateProdi} onClose={() => setShowUpdateProdi(false)}>
        <FormUpdateProdi
          closeModal={() => setShowUpdateProdi(false)}
          selectedRow={selectedRow}
        />
      </Modal>
    </React.Fragment>
  );
}
